import React, { createContext, useContext, useEffect, useState, useReducer} from 'react'
import { Table, Button, Input, Select, Modal, Space, TreeSelect, Form,Tag} from 'antd'
import { StateContext } from '../../../state';
import http from '../../../../../utils/server'
import { SearchOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import './index.less'
import Draggable from 'react-draggable';
import { Mode } from '../../../../../App';
import Sign from '../../../sign';
import DeviceNew from './addNew';
import DeviceFix from './update';
var changeDev = false;
export const DeviceContext = createContext();
function exportCsv(obj) {
    var title = obj.title;
    var titleForKey = Object.keys(obj.data[0]);
    var data = obj.data;
    var str = [];
    str.push(obj.title.join(",") + "\n");
    for (var i = 0; i < data.length; i++) {
        var temp = [];
        for (var j = 0; j < titleForKey.length; j++) {
            temp.push(data[i][titleForKey[j]]);
        }
        str.push(temp.join(",") + "\n");
    }
    var blob = new Blob(['\uFEFF' + str.join('')], {
        type: 'text/plain;charset=utf-8',
    });
    var downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "export.csv";
    downloadLink.click();
}

function findUserDis(nop, list, districts,userDis) {
    if (list&&districts) {
        const nops = list.filter(x => { return x.parent === nop })
        if (nops.length === 0) {
            return
        } else {
            for (var j = 0; j < nops.length; j++) {
                let tempDis=districts.filter(x=>x.user===nops[j].id);
                tempDis.length>0&&userDis.push(...tempDis);
                findUserDis(nops[j].id, list,districts,userDis);
            }
        }
    }
}

function formatDateTimes(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  };


export const  DeviceManage=(props) =>{
    const [form] = Form.useForm()
    const { state, dispatch } = useContext(StateContext)
    const [actDevice, dispatchDevice] = useReducer((state, action) => {
        if (action.type === 'update') {
            return action.device
        } else if (action.type === 'clear') {
            let now = new Date();
            Mode==='soc'?now.setFullYear(now.getFullYear() + 1):now.setFullYear(now.getFullYear() + 100);
            if(Mode==='soc'){
                return {
                    name: '测点',//测点名称
                    type: 201,//主机类型
                    sn: '',
                    sim: '',
                    m_name: '',
                    node: 1,
                    district: '',
                    humi: 0,
                    hide: 0,
                    door_alarm: 0,
                    power_alarm: 0,
                    location: 2,
                    status: 0,
                    expire: now,
                    time: new Date(),
                    iccid_expire:new Date('2000-01-01'),
                    iccid:'0',
                    cardedittime:new Date(),
                }
            }else{
                return {
                    name: '测点',//测点名称
                    type: 201,//主机类型
                    sn: '',
                    sim: '',
                    m_name: '',
                    node: 1,
                    district: '',
                    humi: 0,
                    hide: 0,
                    door_alarm: 0,
                    power_alarm: 0,
                    location: 2,
                    status: 0,
                    expire: now,
                    time: new Date()
                }
            }
            
        }
        return state
    }, []);
    const [showNewModel, setShowNewModel] = useState(false)
    const [showFixModel, setShowFixModel] = useState(false)
    const [tableData, setTableData] = useState([]);//显示表格的数据源
    const [exportData, setExportData] = useState([]);//导出表格的数据源
    const [selDis, setSelDis] = useState([]);//选择的区域
    const [selUser, setSelUser] = useState(0);//树选择的用户
    const [selUserDis, setSelUserDis] = useState([]);//用户关联的区域 用户为空选择全部区域
    const [defExpend,setDefExpend]=useState([]);//树默认展示列表
    const [modalBounds,setModalBounds] = useState({left: 0, top: 0, bottom: 0, right: 0 });//对话框移动坐标
    const [modalMoveDisabled, setModalMoveDisabled] = useState(true);//对话框拖动功能关闭
    const draggleRef = React.createRef();
    const nodeSerch = React.createRef();
    const devSerch = React.createRef();
    const simSerch = React.createRef();
    const [filterCol,setFilterCol] =  useState('');
    const [tableLoad,setTableLoad] =  useState(true);
    const [showDevC,setShowDevC] = useState(false);
    const [devCustom ,setDevCustom] = useState('');
    const [selDevCID,setSelDevCID] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);//选中的关键值
    // const [defFilter,setDefFilter] = useState('')
    const [showSgin,setShowSgin] = useState(false)
    const [mySgin,setMySgin] = useState('')
    const [sgin,setSgin] = useState('')
    const [sginEnable,setSginEnable] = useState(false)
    useEffect(() => {
        setTableLoad(true)
        http.get("/v1/device", {}, {
            // 这里就是关键：Axios 的原生配置
            onDownloadProgress: (progressEvent) => {
              // 注意：对于普通 JSON，这个回调可能只会触发一次（100%）
              // 或者根本不触发，取决于数据大小和浏览器实现
              if (progressEvent.total) {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                console.log(`数据下载进度: ${percent}%`);
                // setProgress(percent); // 更新状态
              }
            }
          }).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) });
                let dev =[]
                if(props.location?.state){
                    if(state.selUser_dev&&state.selUser_dev!==''){
                        dev = data.data.filter(x=>x.user_name===state.selUser_dev);
                    }else{
                        dev = data.data.filter(x=>x.user_name===props.location.state.user_name)
                    }
                }else{
                    dev = data.data
                }
                setTableData(dev);
                setTableLoad(false)
            }
        })
        http.get("/v1/devicetype", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'devicetype', devicetype: data.data });
            }
        })

        http.get("/v1/district", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'district', district: data.data });
                setSelUserDis(data.data)
            }
        })
        http.get("/v1/users", {}).then(data => {
            if (data.code === 0) {
                let temp = data.data.sort((a,b)=>a.name.localeCompare(b.name,'zh'));
                dispatch({ type: 'systemuser', systemuser: temp }) ; 
                if(data.data.length>0){
                    var list = [];
                    temp.filter(x=>x.parent===state.main.id).map(m=>list.push(m.id+""));
                    setDefExpend(list);         
                }     
            }
        })
    }, [state.selUser_dev])
    useEffect(()=>{
        let todo = state.mainTodo;
        let todoCon = todo===''?null:JSON.parse(todo)
        if(todoCon&&todoCon.sginEnable){
            setSginEnable(true);
            setMySgin(todoCon.mySgin?todoCon.mySgin:'')
        }
    },[state.mainTodo])
    const columns = [
        {
            title: '所属用户',
            align: 'center',
            render: (text, record) => (
                <div>
                    {
                        state.district.filter(x => x.id === record.district).length > 0 ?
                        state.systemuser.list.filter(x => x.id === state.district.filter(x => x.id === record.district)[0].user).length > 0 ?
                        state.systemuser.list.filter(x => x.id === state.district.filter(x => x.id === record.district)[0].user)[0].title : '无' : '无'
                    }
                </div>
            ),
            className:Mode==='local'&&'notshow'
        },
        {
            title: '所属区域',
            dataIndex: 'district_name',
            // key: 'id',
            align: 'center',
        },
        //测点名称
        {
            title: '测点名称',
            dataIndex: 'name',
            // key: 'id',
            align: 'center',
            render: (value, record) => (
                <div>
                    <div>
                        {
                            record.name
                        }
                    </div>
                    <div style={{ fontSize: 10, color: '#666' }}>
                        {
                            'ID:' + ((record.node * 1 < 10) ? '0' + record.node : record.node)
                        }
                    </div>
                </div>
            ),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={nodeSerch}
                        placeholder='设备信息'
                        value={selectedKeys[0]}
                        onChange={e => {
                            let val = e.target.value;
                            setSelectedKeys(val ? [val] : [])
                        }}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {
                            clearFilters()
                        }}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  setTimeout(() => nodeSerch.current.focus({cursor: 'all'}), 100);//全选
                }
              },
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

            onFilter: (value, record) =>{
                return record['node']||record['name']? 
                (record['node'].toString().toLowerCase().includes(value.toLowerCase()) ||
                record['name'].toLowerCase().includes(value.toLowerCase()))
                : ''
            }
                ,
        },
        //主机名称
        {
            title: '主机名称',
            dataIndex: 'm_name',
            // key: 'id',
            align: 'center',
            render: (value, record) => (
                <div>
                    <div>
                        {
                            record.m_name
                        }
                    </div>
                    <div style={{ fontSize: 10, color: '#666' }}>
                        {
                            record.sn
                        }
                    </div>
                </div>
            ),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={devSerch}
                        placeholder='主机名称'
                        value={selectedKeys[0]}
                        onChange={e => {
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {
                            clearFilters()
                        }}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  setTimeout(() => devSerch.current.focus({cursor: 'all'}), 100);
                }
              },
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

            onFilter: (value, record) =>
                record['m_name']||record['sn']
                    ? record['m_name'].toString().toLowerCase().includes(value.toLowerCase())||record['sn'].toString().toLowerCase().includes(value.toLowerCase())
                    : '',
        },
        //设备类型
        {
            title: '设备类型',
            dataIndex: 'type',
            width:100,
            // key: 'id',
            align: 'center',
            sorter: {
                compare:(a, b) => a.type - b.type,
                multiple: 5,
            },
            render: (text, record) => (
                <div>
                    {
                        state.devicetype.filter(x => { return x.code === record.type }).length > 0 ? state.devicetype.filter(x => { return x.code === record.type })[0].value : '无'
                    }
                </div>
            )
        },
        //SIM卡号
        {
            title: 'SIM卡号',
            width:130,
            dataIndex: 'sim',
            // key: 'id',
            align: 'center',
            sorter: {
                compare: (a, b) => a.sim - b.sim,
                multiple: 1,
            },
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) =>
            (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={simSerch}
                        placeholder='sim卡号'
                        value={selectedKeys[0]}
                        onChange={e => {
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }}
                        onPressEnter={() => confirm()}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button size="small" style={{ width: 90 }} onClick={() => {
                            clearFilters();
                        }}>
                            重置
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => confirm()}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            查找
                        </Button>

                    </Space>
                </div>
            ),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                  setTimeout(() => simSerch.current.focus({cursor: 'all'}), 100);
                }
              },
            filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,

            onFilter: (value, record) =>
                record['sim']
                ? record['sim'].includes(value)
                : '',
        },
        //添加时间
        // {
        //     title: '添加时间',
        //     dataIndex: 'time',
        //     width:100,
        //     // key: 'id',
        //     align: 'center',
        //     sorter:{
        //         compare: (a, b) => Date.parse(a.time.replace(/T|Z/g, ' ').trim()) - Date.parse(b.time.replace(/T|Z/g, ' ').trim()),
        //         multiple: 2,
        //     },
        //     render:(text, record)=>text= text.slice(0,10)
            
        // },
        //设备到期时间
        {
            title: '到期时间',
            dataIndex: 'expire',
            width:100,
            align: 'center',
            sorter: {
                compare:(a, b) => Date.parse(a.expire.replace(/T|Z/g, ' ').trim()) - Date.parse(b.expire.replace(/T|Z/g, ' ').trim()),
                multiple: 3,
            },
            render:(text, record)=>text= text.slice(0,10),
        },
        //卡到期时间
        {
            title: '卡到期时间',
            dataIndex: 'iccid_expire',
            width:100,
            align: 'center',
            sorter: {
                compare:(a, b) => Date.parse(a.iccid_expire.replace(/T|Z/g, ' ').trim()) - Date.parse(b.iccid_expire.replace(/T|Z/g, ' ').trim()),
                multiple: 3,
            },
            render:(text, record)=>text= text?text.slice(0,10):'',
        },
        //状态
        {
            title: '状态',
            dataIndex: 'expirestatus',
            width:80,
            align: 'center',
            sorter: {
                compare:(a, b) => Date.parse(a.expire.replace(/T|Z/g, ' ').trim()) - Date.parse(b.expire.replace(/T|Z/g, ' ').trim()),
                multiple: 4,
            },
            render: (text, record) => {
                let days = parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24);
                return (
                <div>
                    {
                        days < 0 ? '已到期' : days < 30 ? '即将到期' : '正常'
                    }
                </div>
            )},
            filters: [
                {
                    text: '正常',
                    value: 2
                },
                {
                    text: '即将到期',
                    value: 1
                },
                {
                    text: '已到期',
                    value: 0
                },
            ],
            // filteredValue: defFilter ,
            onFilter: (value, record) => {
                if (value === 2) return parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) >= 30;
                if (value === 1) return (parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) >= 0 && parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) < 30);
                if (value === 0) return parseInt((new Date(record.expire).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24) < 0;
            },
        },
        {
            title: 'IMEI',
            dataIndex: 'imei',
            align: 'center',
            width:100,
        },
        {
            title: '备注',
            dataIndex: 'custom',
            align: 'center',
            width:100,
        },
        {
            title: '操作',
            width:140,
            dataIndex: 'operation',
            align: 'center',
            render: (text, record) => (
                <div >
                    <Button size='small' style={{ marginLeft: '5px',borderRadius:10 }} type="primary" onClick={() => {
                        setShowFixModel(true)
                        changeDev = true;
                        dispatchDevice({ type: 'update', device: record })
                    }}>
                        修改
                    </Button>
                    <Button size='small' type='primary' danger style={{ marginLeft: '5px' ,borderRadius:10}} onClick={() => {
                        Modal.confirm({
                            centered: true,
                            title: `确定要删除设备${record.name}吗？`,
                            icon: <ExclamationCircleOutlined />,
                            content: `编号:${record.sn}测点:${record.node}删除之后将不可恢复！！`,
                            okText: '删除',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                http.delete("/v1/device/" + record.id, { data: record }).then((data) => {
                                    http.get("/v1/device", {}).then(data => {
                                        if (data.code === 0) {
                                            dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                                            let temp=[];
                                            if(selDis.length===0&&selUser===0){
                                                temp=data.data;
                                            }else if(selDis.length===0&&selUser!==0){
                                                let userDis = state.district.filter(x=>x.user===selUser);
                                                findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                                userDis.map(item=>{
                                                    temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                                })
                                            }else if(selDis.length>0){
                                                selDis.map(item=>{
                                                    temp= temp.concat(data.data.filter(x=>x.district === item));
                                                })
                                            }
                                            setTableData(temp);
                                        }
                                    })
                                })
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        });

                    }}>
                        删除
                    </Button>
                    {
                        Mode==='soc'&& state.main.type<102 &&
                        <Button size='small' type='primary'  style={{ marginLeft: '5px' ,borderRadius:10}} onClick={()=>{
                            setShowDevC(true)
                            setSelDevCID(record.id)
                            setDevCustom(record.custom)
                        }}>
                            备注
                        </Button>
                    }
                </div>
            ),
        },
    ]
    const onStart = (event, uiData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) return;
        setModalBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };
    const onfinish = (values) => {
        const {simauto,cardedittimeauto,iccid1,simdate,...newvalues} = values
        if(newvalues.sim.length===20 ){
            newvalues.sim = iccid1;
        }
        if (changeDev) {
            if(Mode==='soc'){
                http.put("/v1/device/" + actDevice.id, {
                    ...newvalues,
                    status: actDevice.status, node: Number(values.node),                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                    sn: Number(values.sn),
                    humi: values.humi ? 1 : 0,
                    door_alarm: values.door_alarm ? 1 : 0,
                    hide: values.hide ? 1 : 0,
                    power_alarm: values.power_alarm_soc?12002:values.power_alarm ? 1 : 0,
                    status: values.status ? 1 : 0,
                    expire:values.expire? values.expire.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.expire),
                    time: values.time?values.time.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.time),
                    iccid_expire:values.iccid_expire?values.iccid_expire.format("YYYY-MM-DD 00:00:00"):actDevice.iccid_expire,
                    imei:actDevice.imei,
                    custom:actDevice.custom,
                    upSn:actDevice.upSn,
                    cardedittime:values.cardedittime?values.cardedittime.format("YYYY-MM-DD hh:mm:ss"):formatDateTimes(actDevice.cardedittime),
                },sgin).then((data) => {
                    http.get("/v1/device", {}).then(data => {
                        if (data.code === 0) {
                            dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                            let temp=[];
                            if(selDis.length===0&&selUser===0){
                                temp=data.data;
                            }else if(selDis.length===0&&selUser>0){
                                let userDis = state.district.filter(x=>x.user===selUser);
                                findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                userDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                })
                            }else if(selDis.length>0){
                                selDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item));
                                })
                            }
                            setTableData(temp);
                        }
                    })
                })
            }else{
                http.put("/v1/device/" + actDevice.id, {
                    ...newvalues,
                    node: Number(values.node),
                    sn: Number(values.sn),
                    humi: values.humi ? 1 : 0,
                    door_alarm: values.door_alarm ? 1 : 0,
                    power_alarm: values.power_alarm ? 1 : 0,
                    hide: values.hide ? 1 : 0,
                    status: values.status?1:0, 
                    expire:values.expire? values.expire.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.expire),
                    time: values.time?values.time.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.time),
                }).then((data) => {
                    http.get("/v1/device", {}).then(data => {
                        if (data.code === 0) {
                            dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                            let temp=[];
                            if(selDis.length===0&&selUser===0){
                                temp=data.data;
                            }else if(selDis.length===0&&selUser>0){
                                let userDis = state.district.filter(x=>x.user===selUser);
                                findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                userDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                })
                            }else if(selDis.length>0){
                                selDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item));
                                })
                            }
                            setTableData(temp);
                        }
                    })
                })
            }
            
        } else {
            if(Mode==='soc'){
                http.post("/v1/device", {
                    ...newvalues,
                    node: Number(values.node),
                    sn: Number(values.sn),
                    humi: values.humi ? 1 : 0,
                    door_alarm: values.door_alarm ? 1 : 0,
                    power_alarm: values.power_alarm ? 1 : 0,
                    hide: values.hide ? 1 : 0,
                    status: values.status ? 1 : 0,
                    expire: values.expire?values.expire.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.expire),
                    time: values.time?values.time.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.time),
                    iccid_expire:values.iccid_expire?values.iccid_expire.format("YYYY-MM-DD 00:00:00"):actDevice.iccid_expire+' 00:00:00',
                    cardedittime:values.cardedittime?values.cardedittime.format("YYYY-MM-DD hh:mm:ss"):formatDateTimes(actDevice.cardedittime),
                }).then((data) => {
                    http.get("/v1/device", {}).then(data => {
                        if (data.code === 0) {
                            dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) });
                            let temp=[];
                            if(selDis.length===0&&selUser===0){
                                temp=data.data;
                            }else if(selDis.length===0&&selUser>0){
                                let userDis = state.district.filter(x=>x.user===selUser);
                                findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                userDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                })
                            }else if(selDis.length>0){
                                selDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item));
                                })
                            }
                            setTableData(temp);
                        }
                    })
                })
            }else{
                http.post("/v1/device", {
                    ...values,
                    node: Number(values.node),
                    sn: Number(values.sn),
                    humi: values.humi ? 1 : 0,
                    door_alarm: values.door_alarm ? 1 : 0,
                    power_alarm: values.power_alarm ? 1 : 0,
                    hide: values.hide ? 1 : 0,
                    status: values.status ? 1 : 0,
                    expire: values.expire?values.expire.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.expire),
                    time: values.time?values.time.format("YYYY-MM-DD 00:00:00"):formatDateTimes(actDevice.time),
                }).then((data) => {
                    http.get("/v1/device", {}).then(data => {
                        if (data.code === 0) {
                            dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) });
                            let temp=[];
                            if(selDis.length===0&&selUser===0){
                                temp=data.data;
                            }else if(selDis.length===0&&selUser>0){
                                let userDis = state.district.filter(x=>x.user===selUser);
                                findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                userDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                })
                            }else if(selDis.length>0){
                                selDis.map(item=>{
                                    temp= temp.concat(data.data.filter(x=>x.district === item));
                                })
                            }
                            setTableData(temp);
                        }
                    })
                })
            }
            
        }

    }
    const onSelectChange = (selectedRowKeys,selectedRows) => {
        setSelectedRows(selectedRows)
        
    };
    const rowSelection = {
        onChange: onSelectChange,
        // getCheckboxProps: (record) => ({
        //     disabled: record.status === 1||record.type%2!==0, // Column configuration not to be checked
        // }),
    };
    return (
        <div style={{height:'100%', padding: 10,position:'relative',background:'#fff' }}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:10,border:'1px solid #ccc',borderRadius:5,padding:10}}>
                <div >
                {
                    Mode==='soc'?<TreeSelect
                    showSearch
                    style={{ width: state.resolution.width>1440?400:250 }}
                    dropdownStyle={{ maxHeight: 500, overflow: 'auto' }}
                    placeholder="选择用户"
                    allowClear
                    optionFilterProp="label"
                    treeDefaultExpandedKeys={defExpend}
                    onChange={value=> {
                        setSelDis([]);//清空关联区域
                        if(value===undefined||value===0){//清空用户选择
                            setTableData(state.device);//默认全部
                            setSelUserDis(state.district);//清空已选择用户的区域
                            setSelUser(0);//清空选择用户给区域选择提供判定条件
                        }else{
                            setSelUser(value);
                            let userDis = state.district.filter(x=>x.user===value);
                            findUserDis(value,state.systemuser.list,state.district,userDis);
                            let temp=[];
                            setSelUserDis(userDis);
                            userDis.map(item=>{
                                temp= temp.concat(state.device.filter(x=>x.district === item.id));
                            })
                            setTableData(temp);
                        }  
                        
                    }}
                    // treeData={[{title:'全部',value:'全部'}].concat(state.systemuser.tree)}
                    treeData={state.systemuser.treeM}
                    filterTreeNode = {(input,option)=>{
                        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 
                        || option.account.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        || option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }}
                    filterOption={(input, option) =>
                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                />:undefined
                }
                <Select allowClear showSearch optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    value={selDis}
                    mode="multiple"
                    style={{ width:state.resolution.width>1440?360:250, marginLeft: 10 }}
                    placeholder="选择区域"
                    onChange={val=>{
                        let temp=[];
                        setSelDis(val);
                        if(val.length===0&&(selUser===0)){
                            temp=state.device;
                        }else if(val.length===0&&selUser>0){
                            let userDis = state.district.filter(x=>x.user===selUser);
                            findUserDis(selUser,state.systemuser.list,state.district,userDis);
                            userDis.map(item=>{
                                temp= temp.concat(state.device.filter(x=>x.district === item.id));
                            })     
                        }else if(val.length>0){
                            val.map(item=>{
                                temp= temp.concat(state.device.filter(x=>x.district === item));
                            })
                        }
                        setTableData(temp);
                    }}
                >
                    {
                        (()=>{
                            // let disData=[]; 
                            let disData=selUserDis;
                            // selUserDis.length>0?disData=selUserDis:disData=state.district
                            return disData.map(item => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            ))
                        })()
                    }
                </Select>
                <Tag style={{marginLeft:10,fontSize:14}} color="cyan">{`主机数量:${tableData.filter(x=>x.node ===1).length}`}</Tag>
                <Tag style={{fontSize:14}} color="green">{`状态位数量:${tableData.filter(x=>x.node===0).length}`}</Tag>
                <Tag style={{fontSize:14}} color="cyan">{`测点数量:${tableData.filter(x=>x.node!==0&&x.type!==213).length}`}</Tag>
                <Tag style={{fontSize:14}} color="green">{`显示条数:${tableData.length}`}</Tag>
                {
                    tableData.filter(x=>x.node>0&&x.type===213).length>0&&
                    <Tag style={{fontSize:14}} color="cyan">{`警灯数量:${tableData.filter(x=>x.node>0&&x.type===213).length}`}</Tag>
                }
                </div>
                <div >
                    {
                        Mode==='soc'&& state.main.type<101 &&
                        <Button size='small' type='primary'  style={{ marginLeft: '5px' ,borderRadius:10}} onClick={()=>{
                            let selSn = []
                            selectedRows.map(item=>{
                                if(item.location<2||item.location>1000){
                                    if(selSn.length===0){
                                        selSn.push(item.sn)
                                    }else{
                                        !selSn.includes(item.sn)&&selSn.push(item.sn)
                                    }
                                    
                                }
                            })
                            http.put('/v1/deviceslocation',{
                                devices:selSn,
                                location:true
                            }).then(res=>console.log(res)
                            )
                            
                        }}>
                            位置
                        </Button>
                    }
                    {
                        Mode==='soc'&& state.main.type<101 &&
                        <Button size='small' type='primary'  style={{ marginLeft: '5px' ,borderRadius:10}} onClick={()=>{
                            let selSn = []
                            selectedRows.map(item=>{
                                if(item.location<2||item.location>1000){
                                    if(selSn.length===0){
                                        selSn.push(item.sn)
                                    }else{
                                        !selSn.includes(item.sn)&&selSn.push(item.sn)
                                    }
                                    
                                }
                            })
                            http.put('/v1/deviceslocation',{
                                devices:selSn,
                                location:false
                            }).then(res=>console.log(res)
                            )
                            
                        }}>
                            取消
                        </Button>
                    }
                    {
                        <Button onClick={() => {
                            // let exDev=JSON.parse(JSON.stringify(tableData));
                            let exDev = [];
                            let exDevIndex =1;
                            tableData.filter(x=>x.node!==0).map(m=>{
                                let temp = {};
                                temp.id = exDevIndex;
                                temp.user_name = m.user_name;
                                temp.district_name = m.district_name;
                                temp.m_name = m.m_name;
                                temp.sn = m.sn;
                                temp.node = m.node;
                                temp.name = m.name;
                                temp.type= m.type===201?'监测主机':m.type===202?'保温箱':m.type===203?'车载':m.type===209?'902保温箱':m.type===208?'无限设备':m.type===205?'压力传感器':'其他'
                                temp.time = m.time;
                                temp.expire = m.expire;
                                temp.sim = m.sim;
                                temp.iccid = m.iccid;
                                temp.iccid_expire = m.iccid_expire;
                                temp.custom = m.custom;
                                exDevIndex++;
                                exDev.push(temp)
                            })
                            if(filterCol.name){
                                let val = filterCol.name[0];
                                exDev=exDev.filter(x=>x.name.indexOf(val)!==-1||(x.node+'').indexOf(val)!==-1);
                            }
                            if(filterCol.m_name){
                                let val = filterCol.m_name[0];
                                exDev=exDev.filter(x=>x.m_name.indexOf(val)!==-1||(x.sn+'').indexOf(val)!==-1);
                            }
                            if(filterCol.sim){
                                let val = filterCol.sim[0];
                                exDev=exDev.filter(x=>x.sim.indexOf(val)!==-1);
                            }
                            if(filterCol.expirestatus){
                                let len = filterCol.expirestatus.length;
                                let arr = filterCol.expirestatus;
                                let arrDev=[];
                                for (let index = 0; index < len; index++) {
                                    let val =arr[index];
                                    let t;
                                    if(val===0){
                                        t = exDev.filter(x=>(new Date(x.expire).getTime()-new Date().getTime())/ 1000 / 60 / 60 / 24< 0);
                                    }
                                    if(val===1){
                                        t = exDev.filter(x=>{
                                            let day = (new Date(x.expire).getTime()-new Date().getTime())/ 1000 / 60 / 60 / 24;
                                            return day<30 && day>=0
                                        });
                                    }
                                    if(val===2){
                                        t = exDev.filter(x=>(new Date(x.expire).getTime()-new Date().getTime())/ 1000 / 60 / 60 / 24 >= 30);
                                    }
                                    arrDev=arrDev.concat(t);
                                }
                                exDev = arrDev;
                            }
                            exportCsv({
                                title: ["序号","用户名",'区域名称',"设备名称",'设备编号',"测点ID",'测点名称',"设备类型",'添加时间',
                                        "到期时间",'sim卡号',"sim卡iccid","sim卡到期时间","备注"],
                                data: exDev
                            })
                        }}>
                            导出CSV
                        </Button>
                    }
                    {
                        (state.main.type<103||(Mode!=='soc'&&state.main.type!==104))&&
                        <Button style={{ backgroundColor: 'green', color: '#fff', borderRadius: 10 }}
                            onClick={() => {
                                setShowNewModel(true)
                                dispatchDevice({ type: 'clear' })
                            }}>新建设备
                        </Button>
                    }
                    
                </div>
            </div>
            <div style={{position:'absolute',width:'100%',height:'100%',overflowY:'auto'}}>
                <Table rowSelection={state.main.type<101? rowSelection:undefined} bordered pagination={{ showSizeChanger:true,hideOnSinglePage:true }} rowKey={record => record.id} size='small' dataSource={tableData}  loading={tableLoad}
                columns={Mode==='soc'?state.main.type>101?columns.filter(x=>x.title!=='卡到期时间'&&x.title!=='IMEI'&&x.title!=='备注'):columns
                    :columns.filter(x=>x.title!=='所属用户'&&x.title!=='到期时间'&&x.title!=='卡到期时间'&&x.title!=='状态'&&x.title!=='IMEI'&&x.title!=='备注')} 
                    onChange={(page,fil)=>{
                        setFilterCol(fil)
                    }}
                    scroll={{y:state.resolution.height<700?400:state.resolution.height<800?500:state.resolution.height<900?600:700,x:'100%'}}
                />
            </div>
            <div>
            {
                showSgin&&<Sign getMySgin={(val)=>{
                    setShowSgin(false);
                    setTimeout(() => {
                        if(val===mySgin){
                            setSgin(val);
                            form.submit()
                        }else{
                            setSgin('');
                            Modal.error({
                                title: '错误',
                                centered: true,
                                content: '电子签名不匹配',
                            });
                        }
                    }, 500);
                    
                }} val ={showSgin}></Sign>
            }
        </div>
        {/* 增加 */}
            <Modal maskClosable={false} title={
                    <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        setModalMoveDisabled(false);
                    }}
                    onMouseOut={() => {
                        setModalMoveDisabled(true);
                    }}
                    >
                    新增设备
                    </div>
                } visible={showNewModel}
                destroyOnClose 
                modalRender={modal => (
                    <Draggable
                      disabled={modalMoveDisabled}
                      bounds={modalBounds}
                      onStart={onStart}
                    >
                      <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                cancelText='取消'
                width={600}
                okText='确定'
                onOk={() => {
                    form.submit();
                }}
                onCancel={() => {
                    setShowNewModel(false)
                    dispatchDevice({ type: 'clear' })
                }}>
                <DeviceContext.Provider value={{ actDevice, dispatchDevice, form, onfinish }}>
                    <DeviceNew isShowUser={true} />
                </DeviceContext.Provider>
            </Modal>
            {/* 修改 */}
            <Modal maskClosable={false} title={
                    <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        setModalMoveDisabled(false);
                    }}
                    onMouseOut={() => {
                        setModalMoveDisabled(true);
                    }}
                    >
                    修改设备
                    </div>
                }  visible={showFixModel}
                destroyOnClose style={{cursor: 'move'}}
                modalRender={modal => (
                    <Draggable
                      disabled={modalMoveDisabled}
                      bounds={modalBounds}
                      onStart={onStart}
                    >
                      <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                cancelText='取消'
                // footer={false}
                width={600}
                okText='确定'
                onOk={() => {
                    sginEnable?setShowSgin(true):
                    form.submit()
                }}
                onCancel={() => {
                    setShowFixModel(false)
                    changeDev = false;
                    dispatchDevice({ type: 'clear' })
                }}>
                <DeviceContext.Provider value={{ actDevice, dispatchDevice, form, onfinish }}>
                    <DeviceFix isShowUser={true} />
                </DeviceContext.Provider>
            </Modal>
            <Modal maskClosable={false} title={
                    <div
                    style={{
                        width: '100%',
                        cursor: 'move',
                    }}
                    onMouseOver={() => {
                        setModalMoveDisabled(false);
                    }}
                    onMouseOut={() => {
                        setModalMoveDisabled(true);
                    }}
                    >
                    设备备注
                    </div>
                }  visible={showDevC}
                destroyOnClose style={{cursor: 'move'}}
                modalRender={modal => (
                    <Draggable
                      disabled={modalMoveDisabled}
                      bounds={modalBounds}
                      onStart={onStart}
                    >
                      <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
                cancelText='取消'
                // footer={false}
                width={600}
                okText='确定'
                onOk={() => {
                    http.post("/v1/devicecustom/"+selDevCID, {
                        custom:devCustom
                    }).then(res=>{
                        http.get("/v1/device", {}).then(data => {
                            if (data.code === 0) {
                                dispatch({ type: 'device', device: data.data.sort((a,b)=>a.sn-b.sn) })
                                let temp=[];
                                if(selDis.length===0&&selUser===0){
                                    temp=data.data;
                                }else if(selDis.length===0&&selUser!==0){
                                    let userDis = state.district.filter(x=>x.user===selUser);
                                    findUserDis(selUser,state.systemuser.list,state.district,userDis);
                                    userDis.map(item=>{
                                        temp= temp.concat(data.data.filter(x=>x.district === item.id));
                                    })
                                }else if(selDis.length>0){
                                    selDis.map(item=>{
                                        temp= temp.concat(data.data.filter(x=>x.district === item));
                                    })
                                }
                                setTableData(temp);
                            }
                        })
                        setShowDevC(false)
                    })
                }}
                onCancel={() => {
                    setShowDevC(false)
                }}>
                <div>
                    <Input placeholder = '备注内容' value={devCustom} onChange={e=>{
                        setDevCustom(e.target.value)
                    }}/>
                </div>
            </Modal>
        </div>
    )
}

